import i18n from '@/i18n/i18n';

export default class UserProfile {
  constructor(data) {
    this.id = data.id;
    this.firstname = data.firstname;
    this.lastname = data.lastname;
    this.role = data.role;
    this.email = data.email;
    this.shops = data.shops;
    this.status = data.status;
    this.hasActivePasswordRequest = data.hasActivePasswordRequest;
  }

  get displayName() {
    return `${this.firstname} ${this.lastname}`;
  }

  get displayTitle() {
    return i18n.tc(`roles.${this.role}`);
  }

  get title() {
    return this.displayTitle;
  }
}
